import { Component, Input, ViewChild } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-message-tooltip',
    templateUrl: './message-tooltip.component.html',
    styleUrls: ['./message-tooltip.component.scss'],
    standalone: false
})
export class MessageTooltipComponent extends CfetBaseComponent {

  @Input() message: string;
  @Input() dataPlacement: string;
  @Input() id: string;

  @ViewChild('messageTooltip') private MessageTooltip;

  constructor() { super(); }


  tooltipSonarFix(referenceName) {
    this[referenceName].nativeElement.href = 'javascript:void(0)';
  }

}
